(function (){
    'use strict';

    angular
        .module('app')
        .controller('RootController', RootController);        

    RootController.$inject = ['$state','CurrentUser', '$rootScope', 'AclService', 'AuthService'];
    function RootController ($state, CurrentUser, $rootScope, AclService, AuthService) {
        var vm = this;
        vm.user = JSON.parse(localStorage.getItem("user"));
        vm.checkUser = vm.user.id == '99996' ? true:false;
        vm.checkUser2 = vm.user.id == '520' ? true:false;
        $rootScope.can     = can;
        $rootScope.hasRole = hasRole;
        $rootScope.is_admin = is_admin;

        function activate() {
            var userId =  JSON.parse(localStorage.getItem("user"));
            AclService.resume();
        }

        function can (permission) {
                permission = permission.toLowerCase();
                if(!CurrentUser)
                    return false;
                var roles = CurrentUser.roles.map(function(role){
                    return role.name.toLowerCase();
                });

                if(roles.indexOf('admin') !== -1)
                    return true;
                return AclService.can(permission);
        }

        function hasRole (role_name) {
                role_name = role_name.toLowerCase();
                if(!CurrentUser)
                    return false;
                var roles = CurrentUser.roles.map(function(role){
                    return role.name.toLowerCase();
                });
                if(roles.indexOf('admin') !== -1){
                    return true;
                } else {
                    if(roles.indexOf(role_name) !== -1)
                        return true;
                }
                return false;
        }

        function is_admin () {            
            if(!CurrentUser)
                return false;
            var roles = CurrentUser.roles.map(function(role){
                return role.name.toLowerCase();
            });

            if (roles.indexOf('admin') !== -1)
                return true;
            
            return false;
    }

        activate();
    }
})();